import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { COLLECTIONS, type User } from "@gull/shared";
import { db } from "./firebase";

/**
 * The signed-in customer's own `users/{uid}` document, live.
 *
 * `undefined` means the first snapshot has not arrived yet, `null` that there is no document. The
 * profile form needs that distinction — a spinner for the first, an error for the second — while
 * the banners treat both as nothing to show.
 */
export function useProfile(uid: string | null | undefined): User | null | undefined {
  const [profile, setProfile] = useState<User | null | undefined>(undefined);

  useEffect(() => {
    setProfile(undefined);
    if (!uid) return;
    return onSnapshot(doc(db, COLLECTIONS.users, uid), (snap) => {
      setProfile(snap.exists() ? (snap.data() as User) : null);
    });
  }, [uid]);

  return profile;
}
